module.exports = __webpack_public_path__ + "static/media/Brandon_light.4b818cfa.woff";